import { render, staticRenderFns } from "./father_request_edit.vue?vue&type=template&id=dc4af226&scoped=true&"
import script from "./father_request_edit.vue?vue&type=script&lang=js&"
export * from "./father_request_edit.vue?vue&type=script&lang=js&"
import style0 from "./father_request_edit.vue?vue&type=style&index=0&id=dc4af226&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4af226",
  null
  
)

export default component.exports